// extracted by mini-css-extract-plugin
module.exports = {"actionFooter":"actionFooter_actionFooter__3FJm1","button":"actionFooter_button__1b2JT"};